import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa"; // Import cart icon
import { useCart } from "../../CartContext/CartContextComp"; // Import cart context
import "../../../assets/css/Unavbar.css";
import Umadras from "../../../assets/images/umadras.png";
import CartSlider from "../../CartSlider/CartSliderBar"; // Import cart slider

const Unavbar = () => {
  const { cartItems } = useCart(); // Get cart items
  const [cartOpen, setCartOpen] = useState(false); // Control cart slider visibility

  return (
    <nav className="navbar">
      {/* Logo (Left Side) */}
      <div className="ulogo">
        <Link to="/umadras">
          <img src={Umadras} alt="Logo" className="ulogo-image" />
        </Link>
      </div>

      {/* Nav Links + Cart (Right Side) */}
      <div className="nav-links">
        <Link to="/">Home</Link>
        <Link to="/umadras/collections">Collection</Link>
        <Link to="/umadras#contact">Contact Us</Link>

        {/* Cart Icon */}
        <div className="cart-container" onClick={() => setCartOpen(true)}>
          <FaShoppingCart className="cart-icon" />
          {cartItems.length > 0 && <span className="cart-count">{cartItems.length}</span>}
        </div>
      </div>
      {/* Cart Slider */}
      {cartOpen && (
        <CartSlider cartItems={cartItems} onClose={() => setCartOpen(false)} />
      )}
    </nav>
  );
};

export default Unavbar;
